import React, { useEffect, useRef, useState } from 'react';
import Header from '../../component/Header';
import Sidebar from '../../component/SideBar';
import { Grid, Box, TextField, Button, FormControl, InputLabel, Select, MenuItem, IconButton, ListItemIcon, ListItemText, Input, FormControlLabel, Radio, RadioGroup, FormLabel, Tab } from '@mui/material';
import { image } from "../../../src/common/Theme";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Apiconnection from '../../utils/Apiconnection';
import { useLocation } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js';

const BookingReceipts = () => {
    const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
    const [policies, setPolicies] = useState([]);
    const [invoiceDetails, setInvoiceDetails] = useState(null); // State for invoice details



    const OpenSidebar = () => {
        setOpenSidebarToggle(!openSidebarToggle);
    };

    const printableRef = useRef();

    const [value, setValue] = React.useState('1');
    const [age, setAge] = React.useState('');

    const location = useLocation();
    const navigate = useNavigate();
    const payload = location.state;

    console.log("tranpayload", payload)

    const handleViewInvoice = async () => {
        // navigate('/booking-receipts', { state: id });
        try {
            const response = await Apiconnection.post('invoice-detail', { "bookingRequestId": payload.id, platformMedium: payload.tid === null ? "AdminBooking" : "" });
            console.log('invoice-detail', response)
            if (response.data && response.data.status) {
                const invoiceData = response.data.data;
                const dayCount = calculateDayCount(invoiceData.invoiceDetail.bookingrequest.fromDate, invoiceData.invoiceDetail.bookingrequest.toDate);
                setInvoiceDetails({ ...invoiceData, dayCount });
                console.log('invoiceDetails', invoiceDetails)
            } else {
                console.error('No data found in response:', response.data);
            }
        } catch (error) {
            console.error('Error fetching Invoice details:', error);
        }
    }

    const fetchPolicies = async () => {
        try {
            const response = await Apiconnection.post('get-policies');
            if (response.data && response.data.data && response.data.data.policies) {
                setPolicies(response.data.data.policies);
            } else {
                console.error('Unexpected response structure:', response.data);
                setPolicies('');
            }
        } catch (error) {
            console.error('Error fetching policies:', error);
            setPolicies('');
        }
    };

    useEffect(() => {
        handleViewInvoice();
        fetchPolicies();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    const handlePrint = () => {
        const element = printableRef.current;
        const opt = {
            margin: 0.6,
            filename: 'booking_receipt.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'A4', orientation: 'landscape' }
        };

        html2pdf().from(element).set(opt).save();
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };

    const calculateDayCount = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const timeDifference = end - start; // Difference in milliseconds
        const dayCount = Math.ceil(timeDifference / (1000 * 3600 * 24)) + 1; // Add 1 to include the end date
        return dayCount;
    };

    return (
        <div className='grid-container'>
            <Header OpenSidebar={OpenSidebar} />
            <Sidebar openSidebarToggle={openSidebarToggle} OpenSidebar={OpenSidebar} />
            <div className='inner-container'>
                <Box sx={{ padding: '16px', backgroundColor: '#f5f5f5', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" onClick={handleBack} style={{ marginRight: '10px' }}>Back</Button>
                    <Button variant="contained" onClick={handlePrint}>Print</Button>
                </Box>
                <div className="booking-receipts-sec">
                    <Box sx={{ width: '100%', typography: 'body1' }} ref={printableRef}>
                        {/* <TabContext value={value}> */}
                        {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="All" value="1" />
                                    <Tab label="Office's" value="2" />
                                    <Tab label="Customer's" value="3" />

                                </TabList>
                            </Box> */}
                        <div className='table-responsive'>
                            <table className='top-table' style={{ width: '100%', backgroundColor: '#fff', padding: '40px', margin: '0px' }}>
                                <tr>

                                    {/* <td className="cmn-width">
                                        <table className="common-table">
                                            <tr>
                                                <td style={{ padding: '0' }}>
                                                    <div className="bg-black">
                                                    <h5>Prime Park Receipt</h5>
                                                    <p>+1 800-884-0153</p>
                                                    <p>15115 Lefferts Blvd, South Ozone Park, NY 11420, United States</p>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <table className="body-top">
                                                        <tr>
                                                            <td>
                                                                <div className="check-in">
                                                                    <p>Check In Date & Time</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.fromDate} | {invoiceDetails?.invoiceDetail?.bookingrequest?.selectedCheckInTime}</h3>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="check-in">
                                                                    <p>Check Out Date & Time</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.toDate} | {invoiceDetails?.invoiceDetail?.bookingrequest?.selectedCheckOutTime}</h3>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="check-in">
                                                                    <p>Name</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.user?.firstName} {invoiceDetails?.invoiceDetail?.bookingrequest?.user?.lastName}</h3>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="check-in">
                                                                    <p>Phone number</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.user?.phone}</h3>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="check-in">
                                                                    <p>Ticket ID</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.bookingTicketNo}</h3>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="check-in">
                                                                    <p>Slot Number</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.slot?.slotName}</h3>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    
                                                    </table>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <table className="biling-details mt-3">
                                                        <tr>
                                                            <td>
                                                                <h2>Billing Details</h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <p>Onsite amount Charges</p>
                                                            </td>
                                                            <td>
                                                                <h5>$ {invoiceDetails?.invoiceDetail?.onSiteChargeForVendor}</h5>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="parking-carge">
                                                                    <p>Parking Charges</p>
                                                                    <span>({invoiceDetails?.invoiceDetail?.bookingrequest?.vehicletype?.typeName})</span>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h5>$ {invoiceDetails?.invoiceDetail?.parkingChargeTotal}</h5>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="parking-carge">
                                                                    <p>Overstay Charges</p>
                                                                    <span>({invoiceDetails?.invoiceDetail?.overstayDays} days)</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h5>$ {invoiceDetails?.invoiceDetail?.overstayAmountTotal}</h5>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="parking-carge">
                                                                    <p>Early Check In Charges</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h5>$ {invoiceDetails?.invoiceDetail?.earlyCheckinAmountTotal}</h5>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="parking-carge">
                                                                    <p>Extra Passenger Fees</p>
                                                                    <span>({invoiceDetails?.invoiceDetail?.extraPassengers} Passengers)</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h5>$ {invoiceDetails?.invoiceDetail?.extraPassengerChargesTotal}</h5>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div className="parking-carge">
                                                                    <p>Online Booking Charges (Paid)</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h5>$ {invoiceDetails?.invoiceDetail?.onlineBookingAmount}</h5>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div className="parking-carge">
                                                                    <p>Reservation Fee (Paid)</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h5>$ {invoiceDetails?.invoiceDetail?.reservationAmount}</h5>
                                                            </td>
                                                        </tr>

                                                    </table>
                                                </td>
                                            </tr>


                                            <tr>
                                                <td>
                                                    <table className="bottom-table">
                                                        <tr className="bg-black">
                                                            <td style={{ width: '50%' }}>
                                                                <h5 style={{ textAlign: 'left' ,fontSize:'10px', lineHight: '10px' }}>Total amount to pay</h5>
                                                            </td>
                                                            <td style={{ width: '50%' }}>
                                                                <h5 style={{ textAlign: 'right',fontSize:'10px', lineHight: '10px' }}>$ {invoiceDetails?.invoiceDetail?.dueAmount}</h5>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2">
                                                                <h4>Terms & Conditions</h4>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2">
                                                                <div   dangerouslySetInnerHTML={{ __html: policies }} />
                                                            </td>
                                                        </tr>

                                                        <tr className="Signature">
                                                            <td style={{ verticalAlign: 'middle', width: '10%' }}>
                                                                <div className="check-img">
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h4>I accept the Terms & Conditions</h4>
                                                            </td>
                                                        </tr>
                                                        <tr className="Signature">
                                                            <td></td>
                                                            <td>
                                                                <h4>Customer's Signature</h4>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td></td>
                                                            <td>...................................................</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td> */}

                                    <td className="cmn-width">
                                        <table className="common-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <tr>
                                                <td style={{ padding: 0 }}>
                                                    <div className="bg-black" style={{ padding: '15px', textAlign: 'center', color: 'white' }}>
                                                        <h5 style={{ fontSize: '24px', margin: 0 }}>Prime Park Receipt</h5>
                                                        <p style={{ fontSize: '16px', margin: '5px 0' }}>+1 800-884-0153</p>
                                                        <p style={{ fontSize: '14px', margin: '5px 0' }}>15115 Lefferts Blvd, South Ozone Park, NY 11420, United States</p>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <table className="body-top" style={{
                                                        width: '100%',
                                                        borderCollapse: 'collapse',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '8px',
                                                        fontFamily: 'Arial, sans-serif',
                                                        backgroundColor: '#ffffff'
                                                    }}>
                                                        {/* Header */}
                                                        <tr>
                                                            <td colSpan="2" style={{
                                                                padding: '10px',
                                                                backgroundColor: '#f4f4f4',
                                                                textAlign: 'left',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <h2 style={{
                                                                    fontSize: '18px',
                                                                    margin: '0',
                                                                    color: '#333'
                                                                }}>Reservation Details</h2>
                                                            </td>
                                                        </tr>

                                                        {/* Check-In and Check-Out Details */}
                                                        <tr>
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <p style={{
                                                                    fontSize: '14px',
                                                                    margin: '2px 0',
                                                                    color: '#555'
                                                                }}>Check-In Date & Time</p>
                                                                <h3 style={{
                                                                    fontSize: '16px',
                                                                    margin: '5px 0',
                                                                    color: '#000'
                                                                }}>{invoiceDetails?.invoiceDetail?.bookingrequest?.fromDate} | {invoiceDetails?.invoiceDetail?.bookingrequest?.selectedCheckInTime}</h3>
                                                            </td>
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <p style={{
                                                                    fontSize: '14px',
                                                                    margin: '2px 0',
                                                                    color: '#555'
                                                                }}>Check-Out Date & Time</p>
                                                                <h3 style={{
                                                                    fontSize: '16px',
                                                                    margin: '5px 0',
                                                                    color: '#000'
                                                                }}>{invoiceDetails?.invoiceDetail?.bookingrequest?.toDate} | {invoiceDetails?.invoiceDetail?.bookingrequest?.selectedCheckOutTime}</h3>
                                                            </td>
                                                        </tr>

                                                        {/* Name and Phone Details */}
                                                        <tr>
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <p style={{
                                                                    fontSize: '14px',
                                                                    margin: '2px 0',
                                                                    color: '#555'
                                                                }}>Name</p>
                                                                <h3 style={{
                                                                    fontSize: '16px',
                                                                    margin: '5px 0',
                                                                    color: '#000'
                                                                }}>{invoiceDetails?.invoiceDetail?.bookingrequest?.user?.firstName} {invoiceDetails?.invoiceDetail?.bookingrequest?.user?.lastName}</h3>
                                                            </td>
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <p style={{
                                                                    fontSize: '14px',
                                                                    margin: '2px 0',
                                                                    color: '#555'
                                                                }}>Phone Number</p>
                                                                <h3 style={{
                                                                    fontSize: '16px',
                                                                    margin: '5px 0',
                                                                    color: '#000'
                                                                }}>{invoiceDetails?.invoiceDetail?.bookingrequest?.user?.phone}</h3>
                                                            </td>
                                                        </tr>

                                                        {/* Ticket ID and Slot Number */}
                                                        <tr>
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <p style={{
                                                                    fontSize: '14px',
                                                                    margin: '2px 0',
                                                                    color: '#555'
                                                                }}>Ticket ID</p>
                                                                <h3 style={{
                                                                    fontSize: '16px',
                                                                    margin: '5px 0',
                                                                    color: '#000'
                                                                }}>{invoiceDetails?.invoiceDetail?.bookingrequest?.bookingTicketNo}</h3>
                                                            </td>
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <p style={{
                                                                    fontSize: '14px',
                                                                    margin: '2px 0',
                                                                    color: '#555'
                                                                }}>Slot Number</p>
                                                                <h3 style={{
                                                                    fontSize: '16px',
                                                                    margin: '5px 0',
                                                                    color: '#000'
                                                                }}>{invoiceDetails?.invoiceDetail?.bookingrequest?.slot?.slotName}</h3>
                                                            </td>
                                                        </tr>

                                                        {/* Reservation ID */}
                                                        <tr>
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <p style={{
                                                                    fontSize: '14px',
                                                                    margin: '2px 0',
                                                                    color: '#555'
                                                                }}>Reservation ID</p>
                                                                <h3 style={{
                                                                    fontSize: '16px',
                                                                    margin: '5px 0',
                                                                    color: '#000'
                                                                }}>{invoiceDetails?.carMovementDetail?.reservationId ? invoiceDetails.carMovementDetail.reservationId : 'N/A'}</h3>
                                                            </td>
                                                        </tr>
                                                    </table>


                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <table className="billing-details" style={{
                                                        width: '100%',
                                                        borderCollapse: 'collapse',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '8px',
                                                        fontFamily: 'Arial, sans-serif',
                                                        backgroundColor: '#ffffff'
                                                    }}>
                                                        {/* Header Section */}
                                                        <tr>
                                                            <td colSpan="2" style={{
                                                                padding: '10px',
                                                                backgroundColor: '#f4f4f4',
                                                                textAlign: 'left',
                                                                borderBottom: '1px solid #e0e0e0'
                                                            }}>
                                                                <h2 style={{
                                                                    fontSize: '18px',
                                                                    margin: '0',
                                                                    color: '#333'
                                                                }}>Billing Details</h2>
                                                            </td>
                                                        </tr>

                                                        {/* Total Parking Charges with Break-up */}
                                                        <tr>
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '20px',
                                                                borderRight: '1px solid #e0e0e0',
                                                                verticalAlign: 'top'
                                                            }}>
                                                                <h3 style={{
                                                                    fontSize: '14px',
                                                                    margin: '0',
                                                                    color: '#444'
                                                                }}>Total Parking Charges</h3>
                                                                <div style={{
                                                                    padding: '10px',
                                                                    marginTop: '5px',
                                                                    border: '1px solid #e0e0e0',
                                                                    minHeight: '145px',
                                                                    borderRadius: '5px',
                                                                    backgroundColor: '#f9f9f9'
                                                                }}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
                                                                        <span style={{ fontSize: '14px', color: '#555' }}>Early Check-In Fee:</span>
                                                                        <strong style={{ fontSize: '14px', color: '#000' }}>$ {invoiceDetails?.invoiceDetail?.earlyCheckinAmountTotal}</strong>
                                                                    </div>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
                                                                        <span style={{ fontSize: '14px', color: '#555' }}>Overstay Charges: ({invoiceDetails?.invoiceDetail?.overstayDays} Days)</span>
                                                                        <strong style={{ fontSize: '14px', color: '#000' }}>$ {invoiceDetails?.invoiceDetail?.overstayAmountTotal}</strong>
                                                                    </div>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
                                                                        <span style={{ fontSize: '14px', color: '#555' }}>Extra Passenger: ({invoiceDetails?.invoiceDetail?.extraPassengers} Passengers)  </span>
                                                                        <strong style={{ fontSize: '14px', color: '#000' }}>$ {invoiceDetails?.invoiceDetail?.extraPassengerChargesTotal}</strong>
                                                                    </div>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
                                                                        <span style={{ fontSize: '14px', color: '#555' }}>Parking Charges: ({invoiceDetails?.dayCount} days x ${invoiceDetails?.dailyCharge})({invoiceDetails?.invoiceDetail?.bookingrequest?.vehicletype?.typeName})</span>
                                                                        <strong style={{ fontSize: '14px', color: '#000' }}>$ {invoiceDetails?.invoiceDetail?.parkingChargeTotal}</strong>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            {/* Charges Summary */}
                                                            <td style={{
                                                                width: '50%',
                                                                padding: '20px',
                                                                verticalAlign: 'top'
                                                            }}>
                                                                <h3 style={{
                                                                    fontSize: '14px',
                                                                    margin: '0',
                                                                    color: '#444'
                                                                }}>Other Charges</h3>
                                                                <div style={{
                                                                    padding: '10px',
                                                                    marginTop: '5px',
                                                                    border: '1px solid #e0e0e0',
                                                                    minHeight: '140px',
                                                                    borderRadius: '5px',
                                                                    backgroundColor: '#f9f9f9'
                                                                }}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
                                                                        <span style={{ fontSize: '14px', color: '#555' }}>Onsite Amount Charges:</span>
                                                                        <strong style={{ fontSize: '14px', color: '#000' }}>$ {invoiceDetails?.invoiceDetail?.onSiteChargeForVendor}</strong>
                                                                    </div>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
                                                                        <span style={{ fontSize: '14px', color: '#555' }}>Online Booking Charges:</span>
                                                                        <strong style={{ fontSize: '14px', color: '#000' }}>$ {invoiceDetails?.invoiceDetail?.onlineBookingAmount}</strong>
                                                                    </div>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
                                                                        <span style={{ fontSize: '14px', color: '#555' }}>Total Amount to Pay:</span>
                                                                        <strong style={{ fontSize: '14px', color: '#000' }}>$ {invoiceDetails?.invoiceDetail?.payableAmount}</strong>
                                                                    </div>
                                                                    {(invoiceDetails?.invoiceDetail?.bookingrequest?.transactionHistoryId !== null || invoiceDetails?.invoiceDetail?.paidAmount > 0 || invoiceDetails?.invoiceDetail?.paymentType) && (
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
                                                                            <span style={{ fontSize: '14px', color: '#555' }}>
                                                                                {invoiceDetails?.invoiceDetail?.bookingrequest?.bookingStatus === "Checked Out"
                                                                                    ? "Total Paid Amount:"
                                                                                    : "Amount Paid During Booking Request:"}
                                                                                {invoiceDetails?.invoiceDetail?.paymentType && (
                                                                                    <span style={{
                                                                                        display: 'inline-block',
                                                                                        marginLeft: '8px',
                                                                                        padding: '2px 8px',
                                                                                        fontSize: '11px',
                                                                                        fontWeight: '600',
                                                                                        borderRadius: '4px',
                                                                                        backgroundColor: '#e8f5e9',
                                                                                        color: '#2e7d32',
                                                                                    }}>
                                                                                        Paid via {invoiceDetails?.invoiceDetail?.paymentType}
                                                                                    </span>
                                                                                )}
                                                                            </span>
                                                                            <strong style={{ fontSize: '14px', color: '#000' }}>
                                                                                $ {invoiceDetails?.invoiceDetail?.paidAmount}
                                                                            </strong>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>


                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <table className="bottom-table" style={{ width: '100%', marginTop: '-0.5px', borderCollapse: 'collapse' }}>
                                                        <tr className="bg-black" style={{ backgroundColor: '#333' }}>
                                                            <td style={{ width: '100%', padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px' }}>
                                                                <h5 style={{ textAlign: 'left', fontSize: '20px', lineHeight: '1.42', color: '#fff', margin: 0 }}>Total Due Amount</h5>
                                                                <h5 style={{ fontSize: '20px', lineHeight: '1.42', color: '#fff', margin: 0 }}>$ {invoiceDetails?.invoiceDetail?.dueAmount}</h5>
                                                            </td>
                                                        </tr>

                                                        <tr className='mt-4'>
                                                            <td className='mt-4'>
                                                                <div className="custom-policies mt-4">
                                                                    <h4>Terms & Conditions</h4>
                                                                    <div className='policiesdetails' dangerouslySetInnerHTML={{ __html: policies }} />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2" style={{ textAlign: 'center' }}>
                                                                <div className="scnr-img">
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>

                                    {/* <td class="cmn-width">
                                        <table class="common-table">
                                            <tr>
                                                <td style={{ padding: '0' }}>
                                                    <div class="bg-black">
                                                    <h5>Prime Park Receipt</h5>
                                                    <p>+1 800-884-0153</p>
                                                    <p>15115 Lefferts Blvd, South Ozone Park, NY 11420, United States</p>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <table class="body-top">
                                                        <tr>
                                                            <td>
                                                                <div class="slot">
                                                                    <p>Slot</p>
                                                                    <h2>{invoiceDetails?.invoiceDetail?.bookingrequest?.slot?.slotName}</h2>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="slot">
                                                                    <p>Pickup : Date</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.toDate}</h3>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div class="check-in">
                                                                    <p>Name</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.user?.firstName} {invoiceDetails?.invoiceDetail?.bookingrequest?.user?.lastName}</h3>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="check-in">
                                                                    <p>Phone number</p>
                                                                    <h3>{invoiceDetails?.invoiceDetail?.bookingrequest?.customerMobile}</h3>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <div class="slot bg-white">
                                                                    <p>Reservation ID</p>
                                                                    <h3 style={{textAlign: 'center'}}>{invoiceDetails?.carMovementDetail?.reservationId}</h3>
                                                                </div>
                                                            </td>

                                                        </tr>


                                                    </table>
                                                </td>

                                            </tr>




                                            <tr>
                                                <td>
                                                    <table className="bottom-table">

                                                        <tr>
                                                            <td colSpan="2">
                                                                <h4>Terms & Conditions</h4>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2">
                                                                <div dangerouslySetInnerHTML={{ __html: policies }} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div class="fix-height"></div>
                                                            </td>
                                                        </tr>



                                                    </table>
                                                </td>
                                            </tr>

                                        </table>
                                    </td> */}

                                </tr>
                            </table>
                        </div>
                        {/* </TabContext> */}
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default BookingReceipts;